import vmClient from '../../services/vmClient';
import { InflectionType, InflectionTypeMarshaller } from 'app/constants/enums/InflectionType';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

// A WordForm is an irregular inflection of a word. One example might be an irregular plural
// version of a word (mouse -> mice) or an irregular verb tense (to be -> was)
export interface IWordForm extends IEntity {
  attributes: {
    id: EntityStringId;
    inflectionType: InflectionType;
    form: string;
  };
}

export type WordForm = Entity<IWordForm>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WordForm: IEntityType<IWordForm> = vmClient.defineClass({
  typeName: 'WordForm',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
    inflectionType: {
      type: InflectionType,
      marshaller: InflectionTypeMarshaller,
    },
    form: {
      type: 'string',
      notNull: true,
    },
  },
});
